import { Component } from '@angular/core';

@Component({
  selector: 'muni-shared-combo-icon',
  template: `
    <span class="fa combo-icon"
      ><span class="user-icon"><i class="fa fa-user"></i></span
      ><span class="star-icon"></span
    ></span>
  `,
  styleUrls: ['./combo-icon.component.scss'],
  standalone: false,
})
export class ComboIconComponent {}
